<template>
  <el-container class="con">
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but5" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but5" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>二级商户签约信息查询</span>
      <el-button class="but2">
        <span class="sp2">签约记录</span>
      </el-button>
      <el-table :data="tableData" border :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
        <el-table-column label="签约编号" prop="SubMerSignNo"></el-table-column>
        <el-table-column label="签约时间" prop="createTime"></el-table-column>
        <el-table-column label="签约状态" prop="StatusMessage"></el-table-column>
        <el-table-column label="签约卡号" prop="Account"></el-table-column>
        <el-table-column label="操作">
          <el-button type="primary" size="mini" @click="signOff">解约</el-button>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import {mapGetters} from "vuex";
import {signOff, signQuery} from "../../../api/system/bank_abc";

export default {
  name: "index",
  data(){
    return{
      currentUser:'',
      saleOrgName:'',
      tableData:[]
    }
  },
  computed: {
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    this.signQuery()
  },
  methods: {
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function () {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({path: that.redirect || "/login"}).catch(() => {
          });
        }).catch(() => {
        });
      })
    },
    signQuery() {
      let param = {}
      param.companyId = this.companyOrgs[this.index].id
      param.isDeleted = 0
      // console.log(param)
      signQuery(param).then(res => {
        // console.log(res)
        if (res.code === 200) {
          this.tableData = res.data
        } else {
          this.$modal.msgError("获取签约信息失败，请检查该公司是否签约");
        }
      });
    },
    signOff() {
      this.$confirm('确定解约么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {}
        param.subMerId = this.tableData[0].SubMerId
        param.updateFlag = 4 //解约
        // console.log(param)
        signOff(param).then(res => {
          if (res.code === 200) {
            let jsonRes = JSON.parse(res.data)
            this.$modal.msgSuccess(jsonRes.ErrorMessage);
            this.tableData = []
          } else {
            this.$modal.msgError("获取签约信息失败，请检查该公司是否签约");
          }
        });
      }).catch(() => {
        console.log("取消解约")
      });
    }
  }
}
</script>

<style scoped>
  .text{
    color: rgb(239, 51, 69);
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    margin: 0 8px;
  }
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but5{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    max-width: 100%;
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .sp2{
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
</style>
